import { Component, Input, OnInit } from '@angular/core';
import { CardToken, CardTokenQuery, CardTokenService } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as luxon from 'luxon';

@Component({
  selector: 'fgb-payment-button',
  templateUrl: './payment-button.component.html',
  styleUrl: './payment-button.component.scss',
})
export class PaymentButtonComponent implements OnInit {
  @Input() cardRouteURL: string = '/account';
  cardToken$: Observable<CardToken | undefined>;

  constructor(private cardTokenQuery: CardTokenQuery, private cardTokenService: CardTokenService) {}

  ngOnInit(): void {
    firstValueFrom(this.cardTokenService.fetchCardTokens());
    this.cardToken$ = this.cardTokenQuery
      .selectCard()
      .pipe(map((cardTokens) => cardTokens.find((cardToken) => cardToken.IsDefaultToken) ?? cardTokens[0]));
  }

  isExpiried(expiryDate: string) {
    if (!expiryDate) return false;
    const now = luxon.DateTime.utc();
    const expiriedDate = luxon.DateTime.fromISO(expiryDate);
    return now > expiriedDate;
  }
}
